import { createActions, createReducer } from 'reduxsauce'

export const { Types, Creators } = createActions(
	{
		rendered: null,
		rendering: null,
		hideLoading: null,
		showLoading: null,
		openMobileMenu: null,
		closeMobileMenu: null,
		openPrivateMenu: null,
		closePrivateMenu: null,
		menuOptionPath: ['menuOptionPath'],
		invalidDiscountRoutes: ['invalidDiscountRoutes'],
	},
	{
		prefix: 'site/',
	}
)

const initialState = {
	loading: false,
	rendered: false,
	mobileMenuState: false,
	privateMenuState: false,
	menuOptionPath: '',
	invalidDiscountRoutes: [],
}

const showLoading = (state = initialState) => ({
	...state,
	loading: true,
})

const hideLoading = (state = initialState) => ({
	...state,
	loading: false,
})

const rendering = (state = initialState) => ({
	...state,
	rendered: false,
})

const setInvalidDiscountRoutes = (
	state = initialState,
	{ invalidDiscountRoutes }
) => ({
	...state,
	invalidDiscountRoutes,
})

const rendered = (state = initialState) => ({
	...state,
	rendered: true,
})

const openMobileMenu = (state = initialState) => ({
	...state,
	mobileMenuState: true,
})

const closeMobileMenu = (state = initialState) => ({
	...state,
	mobileMenuState: false,
})

const openPrivateMenu = (state = initialState) => ({
	...state,
	privateMenuState: true,
})

const closePrivateMenu = (state = initialState) => ({
	...state,
	privateMenuState: false,
})

const menuOptionPath = (state = intialState, { menuOptionPath }) => ({
	...state,
	menuOptionPath,
})

export default createReducer(initialState, {
	[Types.RENDERED]: rendered,
	[Types.RENDERING]: rendering,
	[Types.HIDE_LOADING]: hideLoading,
	[Types.SHOW_LOADING]: showLoading,
	[Types.MENU_OPTION_PATH]: menuOptionPath,
	[Types.OPEN_MOBILE_MENU]: openMobileMenu,
	[Types.CLOSE_MOBILE_MENU]: closeMobileMenu,
	[Types.OPEN_PRIVATE_MENU]: openPrivateMenu,
	[Types.CLOSE_PRIVATE_MENU]: closePrivateMenu,
	[Types.INVALID_DISCOUNT_ROUTES]: setInvalidDiscountRoutes,
})
